export default {
    useReverseExchangeRate: 'useReverseExchangeRate',
    useIsoCodesForNames: 'useIsoCodesForNames',
    useGramsForMetals: 'useGramsForMetals',
    currenciesOrder: 'currenciesOrder',
    metalsOrder: 'metalsOrder',
};
